package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveCombat
import fr.manyverse.app.domain.repository.CombatRepository

/**
 * Récupère le combat actif d'une table (snapshot ponctuel, utilisé à la
 * reconnexion pour reprendre l'état en cours).
 */
class GetActiveCombatUseCase(
    private val combatRepository: CombatRepository
) {
    suspend operator fun invoke(tableId: String): Result<ActiveCombat?> =
        combatRepository.getActiveCombat(tableId)
}
